window.sizeAgreement = window.sizeAgreement || {
  'x-small': 'xs',
  'small': 's',
  'medium': 'm',
  'large': 'l',
  'x-large': 'xl',
  'xx-large': 'xxl',
};
 
function updateAvailableSizesModal(clicked_color) {
    var clicked_color_value = clicked_color.closest('.product-modal__swatch-color-border')
                                                .attr('data-variant-value');
    try {
        var color_name_and_size_unavailable = $('#product-modal__select-hidden')
            .find("option[data-variant-title^='"+clicked_color_value+"']")
            .filter("[data-available='false']");
        var unavailable_sizes = [];
        color_name_and_size_unavailable.each(function() {
            var variant_title = $(this).data('variant-title');
            var size = variant_title.replace(clicked_color_value + '-', '');
            if (sizeAgreement[size]) {
                unavailable_sizes.push(sizeAgreement[size]);
            }
        });

        
        $('.product-modal__swatch-container-each--other button').removeClass('unavailable');
        unavailable_sizes = unavailable_sizes.map(function(x){ return x.toUpperCase().trim(); })
        $('.product-modal__swatch-container-each--other button').each(function(){
            if (unavailable_sizes.includes($(this).text().toUpperCase().trim())) {
                $(this).addClass('unavailable');
            }
        });
    } catch (e) {
        console.log(e);
    }
}

function parametrize(color_name) {
    return color_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
}

function getFirstColorName(results) {
    for (let option of results.options) {
        let colorName = parametrize(option.values[0]);
        if (!results.tags.includes(`hide-${colorName}`) && !results.tags.includes(`hide-manual-${colorName}`)) {
            return colorName;
        }
    }
    return null;
}

function cardModalWindow() {
    // Ensure quickshop is initialized only once across all scripts
    if (window.__quickshopInitialized) { return; }
    window.__quickshopInitialized = true;
    if ($("body").hasClass("template-collection") ||
        $("body").hasClass("template-product") ||
        $("body").hasClass("template-search") ||
        $("body").hasClass("template-index") ||
        $("body").is("#z-supply-spring-2021-collection") ||
        $("body").is("#checkout-page") ||
        $("body").hasClass("page_layout--essentials-2022") ||
        $("body").hasClass("template-404") ||
        $("body").is("#marketplace-by-z-supply")) {
        // Trigger Quick View (namespaced to avoid duplicate bindings)
        $("body")
          .off('click.quickshop', ".product-card__quick-view-trigger, .product-card__quick-view-trigger_only")
          .on('click.quickshop', ".product-card__quick-view-trigger, .product-card__quick-view-trigger_only", function () {
            var clickedModalWindowBtn = $(this);
            let clickedColorName = $(clickedModalWindowBtn).closest('.product-card').find('.product-card__swatch-container .product-card__swatch-border.active').attr('data-swatch-name');
            $(".product-modal__container").addClass("active");
            if ( $(clickedModalWindowBtn).attr("data-free-gift-modal") ) {
                // This is mean product in modal window is free gift
                $(".product-modal__container").addClass("free-gift-modal");
            } else {
                $(".product-modal__container").removeClass("free-gift-modal");
            }
            // Set focus on quickshop modal
            try {
              slate.a11y.trapFocus({
                  $container: $('#quickshop-modal'),
                  namespace: 'quickshop_focus'
              });
            } catch (e) {}

            var $productHandle = $(clickedModalWindowBtn).attr("data-product-handle");
            var productId = $(clickedModalWindowBtn).attr("attr-pr-id");
            $.ajax({
                type: 'GET',
                url: "/products/" + $productHandle + ".js",
                dataType: 'json',
                success: function (results) {
                    // Printing out Modal
                    var $description_full = results.description
                    var $description = results.description.split("<!-- details -->")[0];
                    var $price = results.price / 100;

                    if (window.newModalAjaxWindow && window.matchMedia('(max-width: 767px)').matches) {
                        $("#quickshop-modal").addClass("product-modal__container__new");
                        $(".product-modal__content").append(
                            '<div class="product-modal__header w-100 align-self-start d-flex align-items-center justify-content-end">\
                                <button onclick="document.getElementById(\'quickshop-modal\').click()" class="product-modal__close">\
                                    <svg class="close-icon-new" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">\
                                        <path d="M12.4693 1.10555C12.3885 1.02495 12.2791 0.979677 12.165 0.979677C12.0509 0.979677 11.9415 1.02495 11.8607 1.10555L6.68533 6.28255L1.50997 1.10555C1.4699 1.06548 1.42233 1.0337 1.36998 1.01202C1.31763 0.990332 1.26152 0.979172 1.20486 0.979172C1.1482 0.979172 1.09209 0.990332 1.03974 1.01202C0.987389 1.0337 0.939822 1.06548 0.899755 1.10555C0.859688 1.14562 0.827905 1.19318 0.806221 1.24553C0.784537 1.29788 0.773376 1.35399 0.773376 1.41066C0.773376 1.46732 0.784537 1.52343 0.806221 1.57578C0.827905 1.62813 0.859688 1.67569 0.899755 1.71576L6.07676 6.8895L0.899755 12.0649C0.859795 12.1049 0.828118 12.1525 0.806533 12.2048C0.784948 12.2571 0.773877 12.3131 0.773953 12.3697C0.774029 12.4263 0.785249 12.4823 0.806974 12.5346C0.828699 12.5868 0.860504 12.6343 0.900571 12.6743C0.940637 12.7142 0.988183 12.7459 1.04049 12.7675C1.0928 12.7891 1.14885 12.8001 1.20544 12.8001C1.26202 12.8 1.31804 12.7888 1.37029 12.767C1.42255 12.7453 1.47001 12.7135 1.50997 12.6734L6.6837 7.49971L11.8591 12.6751C11.8989 12.7152 11.9464 12.747 11.9986 12.7687C12.0508 12.7904 12.1068 12.8016 12.1634 12.8016C12.2199 12.8016 12.2759 12.7904 12.3281 12.7687C12.3804 12.747 12.4278 12.7152 12.4677 12.6751C12.5483 12.5943 12.5935 12.4849 12.5935 12.3708C12.5935 12.2567 12.5483 12.1473 12.4677 12.0665L7.29391 6.89113L12.4693 1.71576C12.5094 1.67574 12.5413 1.62819 12.563 1.57584C12.5848 1.52348 12.596 1.46735 12.596 1.41066C12.596 1.35396 12.5848 1.29783 12.563 1.24547C12.5413 1.19312 12.5094 1.14557 12.4693 1.10555Z" fill="black"/>\
                                    </svg>\
                                </button>\
                            </div>' +
                            '<div class="product-modal__content__wrap align-self-stretch">'+
                                '<div class="product-modal__content-image__wrapper active-slider-1">' +
                                    '<div class="product-modal__content-image">' +
                                    '</div>' +
                                '</div>' +
                                '<div class="product-modal__content-info">' +
                                    '<div class="wrap-header-price d-flex justify-content-between">\
                                        <h1 class="product-modal__content-title text-left">' + results.title + '</h1>\
                                        <p class="product-modal__content-price">$' + $price + '.00</p>\
                                    </div>' +
                                    '<a class="product-modal__product-url mt-0 border-bottom-0" href="' + results.url + '">View Full Details</a>' +
                                    '<input type="hidden" class="ptitle" value="' + results.title + '">' +
                                    '<input type="hidden" class="pid" value="' + results.id + '">' +
                                    '<input type="hidden" class="ptype" value="' + results.type + '">' +
                                    '<input type="hidden" class="pbrand" value="' + results.vendor + '">' +
                                    '<input type="hidden" class="pprice" value="' + $price + '">' +
                                    '<div class="product-modal__swatch-container"></div>' +
                                    '<select id="product-modal__select-hidden"></select>' +
                                '</div>' +
                            '</div></div>' +
                            '<div class="product-modal__footer align-self-end">\
                                <div class="product-modal__input-atc">\
                                    <div class="product-modal__input-container">\
                                        <label class="product-modal__input-label" for="product-quantity">Quantity</label>\
                                        <button class="product-modal__input-adjust product-modal__input-adjust--minus" aria-label="Decrease item quantity by one">-</button>\
                                        <input class="product-modal__input" value="1" type="text" id="product-quantity">\
                                        <button class="product-modal__input-adjust product-modal__input-adjust--plus" aria-label="Increase item quantity by one">+</button>\
                                    </div>\
                                    <button class="product-modal__add-to-cart btn">ADD TO BAG</button>\
                                </div>\
                            </div>'
                        );
                    } else {
                        $(".product-modal__content").append(
                            '<div class="product-modal__content-image">' +
                            '</div>' +
                            '<div class="product-modal__content-info">' +
                            '<h1 class="product-modal__content-title">' + results.title + '</h1>' +
                            '<input type="hidden" class="ptitle" value="' + results.title + '">' +
                            '<input type="hidden" class="pid" value="' + results.id + '">' +
                            '<input type="hidden" class="ptype" value="' + results.type + '">' +
                            '<input type="hidden" class="pbrand" value="' + results.vendor + '">' +
                            '<input type="hidden" class="pprice" value="' + $price + '">' +
                            '<p class="product-modal__content-price">$' + $price + '</p>' +
                            '<p class="product-modal__content-description">' + $description + '</p>' +
                            '<div class="product-modal__swatch-container"></div>' +
                            '<div class="product-modal__input-atc">' +
                            '<div class="product-modal__input-container">' +
                            '<label class="product-modal__input-label" for="product-quantity">Quantity</label>' +
                            '<button class="product-modal__input-adjust product-modal__input-adjust--minus" aria-label="Decrease item quantity by one">-</button>' +
                            '<input class="product-modal__input" value="1" type="text" id="product-quantity">' +
                            '<button class="product-modal__input-adjust product-modal__input-adjust--plus" aria-label="Increase item quantity by one">+</button>' +
                            '</div>' +
                            '<button class="product-modal__add-to-cart btn">ADD TO BAG</button>' +
                            '</div>' +
                            '<select id="product-modal__select-hidden"></select>' +
                            '<a class="product-modal__product-url" href="' + results.url + '">VIEW FULL DETAILS</a>' +
                            '</div>'
                        )
                    }

                    // Printing Out Swatches
                    $.each(results.options, function (i, option) {
                        var handleizedOption = parametrize(option.name)
                        // Color Swatch
                        if (option.name === 'Color') {
                            // Append Swatch Title (Color)
                            $(".product-modal__swatch-container").append(
                                '<div class="product-modal__wrap__row-color-swatchers d-flex">' +
                                    '<p class="product-modal__swatch-header product-modal__swatch-header--color product-modal__swatch-header--color__new">Color:</p>' +
                                    '<div class="product-modal__swatch-container-each--color product-modal__swatch-container-each" role="group" aria-labelledby="product-modal-swatch-header-' + handleizedOption + '"></div>' +
                                '</div>'
                            )
                            // Append Swatch Items (Eg. red)
                            
                            var firstColorName = getFirstColorName(results);
                            $.each(option.values, function (i, value) {
                                var firstLoop = ""
                                var handleizedValue = value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                                var colorValue = value
                                const normalizeColorName = colorName => colorName.replaceAll(" ", "-").toLowerCase();
                                let activeColor = clickedColorName ? normalizeColorName(clickedColorName) : firstColorName;
                                firstLoop = handleizedValue === activeColor ? "active" : "";
                                
                                var addSwatch = true;
                                if (results.tags.length > 0) {
                                    console.log(results.tags)
                                    $.each(results.tags, function (i, tag) {
                                        if (tag.indexOf("hide-") > -1) {
                                            var prefix = "hide-";
                                            if (tag.indexOf("hide-manual-") > -1) {
                                                prefix = "hide-manual-";
                                            }
                                            newTag = tag.replace(prefix, "").toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                                            if (handleizedValue == newTag) {
                                                addSwatch = false;
                                            }
                                        }
                                    })
                                    if (addSwatch == true) {
                                        var relevantCard = $('div#' +  results.id );
                                        var relevantCardColorSwatch =  relevantCard.find('.product-card__text-container').find('.product-card__swatch-container').find('button[data-swatch-name="'+colorValue+'"]');
                                        var modalWindowColorSwatch;
                                        if (relevantCardColorSwatch.length > 0) {
                                            var backgroundImageCss = relevantCardColorSwatch.find('.product-card__swatch').css('background-image');
                                            if (backgroundImageCss) {
                                                modalWindowColorSwatch = backgroundImageCss.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
                                            } else {
                                                // Fallback or default image if css property is not found
                                                modalWindowColorSwatch = 'https://cdn.shopify.com/s/files/1/0076/7075/9477/files/color-' + handleizedValue + '.png';
                                            }
                                        } else {
                                            modalWindowColorSwatch = 'https://cdn.shopify.com/s/files/1/0076/7075/9477/files/color-' + handleizedValue + '.png';
                                        }
                                        $(".product-modal__swatch-container-each--color").append(
                                            '<div js-modal-variant data-variant-value=' + handleizedValue + ' class="product-modal__swatch-color-border ' + firstLoop + '">' +
                                            '<div class="modal_window-color-label modal_window-color-label__bottom">'+value+'</div>' +
                                            '<button class="product-modal__swatch-color" style="background-color:' + value + '; background-image: url('+modalWindowColorSwatch+')" aria-label="' + value + '"></button>' +
                                            '</div>'
                                        );
                                        if (window.newModalAjaxWindow && window.matchMedia('(max-width: 767px)').matches) {
                                            $('.product-modal__container__new #product-modal-swatch-header-color span').text($(".product-modal__container__new .product-modal__swatch-color-border.active").attr('data-variant-value'));
                                        }
                                    }

                                } else {
                                    $(".product-modal__swatch-container-each--color").append(
                                        '<div js-modal-variant data-variant-value=' + handleizedValue + ' class="product-modal__swatch-color-border ' + firstLoop + '">' +
                                        '<button class="product-modal__swatch-color" style="background-color:' + value + '; background-image: url(https://cdn.shopify.com/s/files/1/0076/7075/9477/files/color-' + handleizedValue + '.png" aria-label="' + value + '"></button>' +
                                        '</div>'
                                    )
                                }
                            });
                        }
                        // Swatch that are not Color
                        else {
                            $(".product-modal__swatch-container").append(
                                `<div class="product-modal__swatch-container-each--other product-modal__swatch-container__${option.name.toLowerCase()} product-modal__swatch-container-each" role="group" aria-labelledby="product-modal-swatch-header-' + handleizedOption + '">` +
                                `<div class="wrap__${option.name.toLowerCase()} d-flex"><p class="product-modal__swatch-header product-modal__swatch-header--${option.name}__new product-modal__swatch-header--other">${option.name}:</p></div>` +
                                '</div>'
                            )
                            $.each(option.values, function (i, value) {
                                var firstLoop = ""
                                if (i == 0) {
                                    firstLoop = "active"
                                }
                                var currentHandleizedValue = value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
                                var currentValue = value;
                                if (currentHandleizedValue == 'x-small') {
                                    currentValue = 'XS'
                                } else if (currentHandleizedValue == 'small') {
                                    currentValue = 'S'
                                } else if (currentHandleizedValue == 'medium') {
                                    currentValue = 'M'
                                } else if (currentHandleizedValue == 'large') {
                                    currentValue = 'L'
                                } else if (currentHandleizedValue == 'x-large') {
                                    currentValue = 'XL'
                                } else if (currentHandleizedValue == 'xsmall-small') {
                                    currentValue = 'XS/S'
                                } else if (currentHandleizedValue == 'small-medium') {
                                    currentValue = 'S/M'
                                } else if (currentHandleizedValue == 'medium-large') {
                                    currentValue = 'M/L'
                                } else if (currentHandleizedValue == 'large-xlarge') {
                                    currentValue = 'L/XL'
                                } else if (currentHandleizedValue == 'one-size') {
                                    currentValue = 'OS'
                                } else if (currentHandleizedValue.indexOf("size-") != -1) {
                                    currentValue = currentHandleizedValue.replace("size-", "")
                                } else if (currentHandleizedValue.indexOf("-months") != -1) {
                                    currentValue = currentHandleizedValue.replace("-months", "")
                                }
                                $(`.wrap__${option.name.toLowerCase()}`).append(
                                    '<button js-modal-variant data-variant-value="' + value + '" class="product-modal__swatch-other ' + firstLoop + '" aria-label="' + value + '">' + currentValue + '</button>'
                                )
                            })
                        }
                    })

                    // Printing out Variant ID into a hidden select
                    $.each(results.variants, function (i, variant) {
                        $handleizedVariantTitle = variant.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
                        if (variant.featured_image != null) {
                            var variantImageSrc = variant.featured_image.src;
                        }
                        $("#product-modal__select-hidden").append(
                            '<option data-available=' + variant.available + ' data-variant-image=' + variantImageSrc + ' data-variant-price=' + variant.price + ' data-variant-title=' + $handleizedVariantTitle + ' data-variant-id="' + variant.id + '">' + $handleizedVariantTitle + '</option>')
                    })
                    // Printing Out images
                    var $selection = "";
                    $(".active[js-modal-variant]").each(function (index) {
                        var $value = $(this).attr("data-variant-value").toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
                        if (index !== 0) {
                            $selection = $selection + "-" + $value;
                        } else {
                            $selection = $selection + $value;
                        }
                    });
                
                    var $selectVariantImage = $("#product-modal__select-hidden option[data-variant-title='" + $selection + "']").attr("data-variant-image");
                    var variantStyleCode = null;
                    var variantStyleColor = null;
                    if (
                        typeof $selectVariantImage === "string" &&
                        $selectVariantImage.includes("/files/")
                    ) {
                        var splitFiles = $selectVariantImage.split("/files/");
                        if (splitFiles.length > 2) {
                            var splitUnderscore = splitFiles[2].split("_");
                            if (splitUnderscore.length > 1) {
                                variantStyleCode = splitUnderscore[0];
                                variantStyleColor = splitUnderscore[1];
                            }
                        }
                    }

                    if (typeof $selectVariantImage !== "undefined" && $selectVariantImage !== null) {
                        if (window.newModalAjaxWindow && window.matchMedia('(max-width: 767px)').matches) {
                            results.images.forEach(img => {
                                if (img.includes(variantStyleCode) && img.includes(variantStyleColor)) {
                                    var lazyloadImage = img.replace(".jpg", '_{width}x.jpg');
                                    var variantImage = '<img src="' + img.replace('.jpg', '_300x.jpg') + '">'
                                    
                                    $(".product-modal__content-image").append(
                                        variantImage
                                    )
                                }
                            }); 

                            $(".product-modal__content-image").slick({
                                slidesToShow: 1,
                                centerMode: true,
                                infinite: false,
                                cssEase: 'ease-out',
                                useTransform: true,
                                speed: 150,
                            });

                            $(".product-modal__content-image").on('beforeChange', function(event, slick, currentSlide, nextSlide){
                                const classPrefix = 'active-slider-';
                                const $wrap = $('.product-modal__content-image__wrapper');

                                $wrap.removeClass(function(index, className) {
                                    return (className.match(/(^|\s)active-slider-\d+/g) || []).join(' ');
                                });

                                $wrap.addClass(classPrefix + (nextSlide + 1));
                            });

                        } else {
                            var lazyloadImage = $selectVariantImage.replace(".jpg", '_{width}x.jpg')
                            var variantImage = '<img class="lazyload" src="' + $selectVariantImage.replace('.jpg', '_300x.jpg') + '" data-src="' + lazyloadImage + '" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-sizes="auto">'
                            $(".product-modal__content-image").append(
                                variantImage
                            ) 
                        }
                    } else {
                        $(".product-modal__content-image").append(
                            '<img src="' + results.featured_image + '"/>'
                        )
                    }
                    
                    // Detect if on load if product is available
                    var $selection = "";
                    $(".active[js-modal-variant]").each(function (index) {
                        var $value = $(this).attr("data-variant-value").toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
                        if (index !== 0) {
                            $selection = $selection + "-" + $value;
                        } else {
                            $selection = $selection + $value;
                        }
                    })
                    var $selectVariantAvailable = $("#product-modal__select-hidden option[data-variant-title='" + $selection + "']").attr("data-available");
                    if ($selectVariantAvailable == "false") {
                        $(".product-modal__add-to-cart").prop("disabled", true).text("Sold Out");
                    } else {
                        $(".product-modal__add-to-cart").prop("disabled", false).text("ADD TO BAG");
                    }




                    // Clicking on Modal Swatch
                    $("[js-modal-variant]").click(function () {
                        var clickedElm = $(this);
                        var $parent = $(clickedElm).closest(".product-modal__swatch-container-each");
                        var $children = $parent.children(".active[js-modal-variant]");

                        var activeVariantId = $(clickedElm).closest("#quickshop-modal").find("#product-modal__select-hidden");

                        $(clickedElm).closest(".product-modal__swatch-container-each").find(".active").removeClass("active"); 
                        $(clickedElm).addClass("active");

                        var sizeCode = $(".product-modal__swatch-container__size").find('.product-modal__swatch-other.active').attr("data-variant-value");
                        var colorCode = $(".product-modal__swatch-container-each--color").find(".product-modal__swatch-color-border.active").attr("data-variant-value");
                        var formatColorSize = colorCode + "-" + sizeCode.toLowerCase().replaceAll(" ", "-");
                        var variantData = $(activeVariantId).find(`option[data-variant-title="${formatColorSize}"]`);
                        
                        var $selectVariantPrice = $("#product-modal__select-hidden option[data-variant-title='" + formatColorSize + "']").attr("data-variant-price");
                        $(".product-modal__content-price").html("$" + $selectVariantPrice / 100)

                        var $selectVariantAvailable = $("#product-modal__select-hidden option[data-variant-title='" + formatColorSize + "']").attr("data-available");
                        if ($selectVariantAvailable == "false") {
                            $(".product-modal__add-to-cart").prop("disabled", true).text("Sold Out")
                        } else {
                            $(".product-modal__add-to-cart").prop("disabled", false).text("ADD TO BAG");
                        }
                        if (window.newModalAjaxWindow && window.matchMedia('(max-width: 767px)').matches) {
                            $(".product-modal__content-image").slick('slickGoTo', 0); 
                            $(".product-modal__content-image").slick('refresh');
                            $(".product-modal__content-image").slick('slickGoTo', 0);
                        } else {
                            $(".product-modal__content-image").empty();
                        }

                        try {
                            var $selectVariantImage = $("#product-modal__select-hidden option[data-variant-title='" + formatColorSize + "']").attr("data-variant-image");
                            var variantStyleCode, variantStyleColor;
                            if (
                                typeof $selectVariantImage === "string" &&
                                $selectVariantImage.includes("/files/")
                            ) {
                                var filesSplit = $selectVariantImage.split("/files/");
                                if (filesSplit.length > 2 && filesSplit[2].includes("_")) {
                                    var underscoreSplit = filesSplit[2].split("_");
                                    variantStyleCode = underscoreSplit[0];
                                    variantStyleColor = underscoreSplit[1];
                                } else {
                                    // fallback if structure is not as expected
                                    throw new Error("Unexpected image URL structure");
                                }
                            } else {
                                // fallback if not a string or missing '/files/'
                                throw new Error("Image URL missing '/files/' or not a string");
                            }
                        } catch (e) {
                            var $selectVariantImage = $("#quickshop-modal.product-modal__container__new .slick-current").attr("src")
                        }
                        
                        
                        if (typeof $selectVariantImage !== "undefined" && $selectVariantImage !== null) {
                            
                            if (window.newModalAjaxWindow && window.matchMedia('(max-width: 767px)').matches) {
                                $('.product-modal__container__new #product-modal-swatch-header-color span').text($(".product-modal__container__new .product-modal__swatch-color-border.active").attr('data-variant-value'));
                                if($(clickedElm)[0].className.includes("swatch-color-border")) {
                                    $("#product-modal-swatch-header-color span").text($(clickedElm).attr('data-variant-value').replaceAll("-", " "));
                                }

                                results.images.forEach(img => {
                                    if (img.includes(variantStyleCode) && img.includes(variantStyleColor)) {
                                        var lazyloadImage = img.replace(".jpg", '_{width}x.jpg');
                                        var variantImage = '<img class="lazyload" src="' + img.replace('.jpg', '_300x.jpg') + '" data-src="' + lazyloadImage + '" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-sizes="auto">'

                                        $(".product-modal__content-image").append(
                                            variantImage
                                        )
                                    }
                                }); 
                                $(".product-modal__content-image").slick('slickGoTo', 0); 
                                $(".product-modal__content-image").slick('refresh');
                                $(".product-modal__content-image").slick('slickGoTo', 0); 
                            } else {
                                var lazyloadImage = $selectVariantImage.replace(".jpg", '_{width}x.jpg')
                                var variantImage = '<img class="lazyload" src="' + $selectVariantImage.replace('.jpg', '_300x.jpg') + '" data-src="' + lazyloadImage + '" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-sizes="auto"></img>'

                                $(".product-modal__content-image").append(
                                    variantImage
                                )
                            }
                           
                        } else {
                            $(".product-modal__content-image").append(
                                '<img src="' + results.featured_image + '"/>'
                            )
                        }
                    })
                    // Clicking on Add to Cart Button
                    $(".product-modal__add-to-cart").click(function () {
                        var $modalWindow = $(this).closest("#quickshop-modal");
                        // var $selection = "";
                        // $(".active[js-modal-variant]").each(function (index) {
                        //     var $value = $(this).attr("data-variant-value").toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
                        //     if (index !== 0) {
                        //         $selection = $selection + "-" + $value;
                        //     } else {
                        //         $selection = $selection + $value;
                        //     }
                        // })

                        var sizeCode = $(".product-modal__swatch-container__size").find('.product-modal__swatch-other.active').attr("data-variant-value");
                        var colorCode = $(".product-modal__swatch-container-each--color").find(".product-modal__swatch-color-border.active").attr("data-variant-value");
                        var formatColorSize = colorCode + "-" + sizeCode.toLowerCase().replaceAll(" ", "-");
                        
                        var $selectVariantId = $("#product-modal__select-hidden option[data-variant-title='" + formatColorSize + "']").attr("data-variant-id");
                        var $inputQuantity = $(".product-modal__input").val();
                        var productForm = $('.product-modal__content-info');
                        window.dataLayer.push({
                            event: 'ee_addToCart',
                            name: productForm.find('.ptitle').val(),
                            id: productForm.find('.pid').val(),
                            price: productForm.find('.pprice').val(),
                            brand: productForm.find('.pbrand').val(),
                            product_type: productForm.find('.ptype').val(),
                            quantity: $inputQuantity,
                            variant: $selectVariantId,
                            g_product_id: "shopify_US_" + productForm.find('.pid').val() + "_" + $selectVariantId
                        });
                        $.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            dataType: 'json',
                            data: 'quantity=' + $inputQuantity + '&id=' + $selectVariantId,
                            id: $selectVariantId,
                            quantity: $inputQuantity,
                            error: function () {
                                console.log("error")
                            },
                            success: function (response) {
                                try {
                                    OrderSummaryUpdater.prototype.refresh();
                                } catch (e) {
                                    console.log(e);
                                }
                                // Remove focus on quickshop modal
                                slate.a11y.removeTrapFocus({
                                    $container: $('#quickshop-modal'),
                                    namespace: 'quickshop_focus'
                                });

                                $(".product-modal__container").removeClass("active");
                                $(".product-modal__content").empty();
                                $("body").css("overflow", "visible")
                                ajaxCart.load();
                                klavioAddedToCartViaAjax(response);
                                handleQuickshopAddToCartMobile(response, $modalWindow);
                            }
                        })
                    })

                    // Minus Button adjust quantity
                    $(".product-modal__input-adjust--minus").click(function () {
                        var $inputVal = parseInt($(".product-modal__input").val());
                        if (($inputVal - 1) > 0) {
                            $(".product-modal__input").val($inputVal - 1)
                        }
                    })
                    // Plus Button adjust quantity
                    $(".product-modal__input-adjust--plus").click(function () {
                        var $inputVal = parseInt($(".product-modal__input").val());
                        $(".product-modal__input").val($inputVal + 1)
                    })

                    try {
                        // Get review info from Yotpo
                        $.get("https://api.yotpo.com/v1/widget/enAOaNpJKUtBdeMh0FV2HDijFDYB2wkWZW9hbG5z/products/" + productId + "/reviews.json", function (data) {
                            if (data.status && data.status.code == 200) {
                                $("<div class='modal-window__yotPo-review'><div class='stars'></div><div class='link'></div></div>").insertAfter(".product-modal__content-price");
                                let summary = data.response.bottomline
                                let fullStar = '<img class="star" src="https://cdn.shopify.com/s/files/1/0076/7075/9477/files/black-star.svg">'
                                let emptyStar = '<img class="star" src="https://cdn.shopify.com/s/files/1/0076/7075/9477/files/gray-empty-star.svg">'

                                if (summary.total_review > 0) {
                                    for (var i = 0; i < 5; i++) {
                                        if (summary.average_score > i) {
                                            $(".modal-window__yotPo-review .stars").append(fullStar);
                                        } else {
                                            $(".modal-window__yotPo-review .stars").append(emptyStar);
                                        }
                                    }
                                }
                                // Add link to product
                                if (summary.total_review == 1) {
                                    $("<a class='link' href='/products/" + $productHandle + "'>" + summary.total_review + " Review</a>").insertAfter(".modal-window__yotPo-review .stars");
                                } else if (summary.total_review > 1) {
                                    $("<a class='link' href='/products/" + $productHandle + "'>" + summary.total_review + " Reviews</a>").insertAfter(".modal-window__yotPo-review .stars");
                                }
                            }
                        }); 
                    } catch {
                        console.error("->  /api.yotpo.com");
                    }
                    if ($('.product-modal__container').hasClass('free-gift-modal')) {
                        // Code to execute when the element has the class
                        // Append '.product-description-text_modal' before first '.product-description-text' element
                        $('.free-gift-modal').find('.product-description-text').first().before('<div class="product-description-text product-description-text_modal"></div>');
                        $('.free-gift-modal').find('.product-description-text').addClass('d-none');
                        $('.free-gift-modal').find('.product-description-text_modal').removeClass('d-none').addClass('d-block');
                        
                        // Append '<p>Select a size and color for your free gift</p>' into '.product-description-text_modal'
                        $('.free-gift-modal').find('.product-description-text_modal').append('<p>Select a size and color for your free gift</p>');

                        // Parse 'fit' from description
                        var $fit = $description_full.match(/<p><strong><span style="text-decoration: underline;" data-mce-style="text-decoration: underline;">FIT<\/span><\/strong><\/p>\n<p>(.*?)<\/p>/);
                        if ($fit) {
                            $('.free-gift-modal').find('.product-modal__swatch-container-each--other').append('<div class="d-block w-100"><p>' + $fit[1] + '</p></div>');
                        }
                    }

                    $(".product-modal__swatch-color-border button").on("click", function () {
                        updateAvailableSizesModal($(this));
                    });

                    updateColorNamePosition();
                }
            });

        });

        // Click close to close modal
        $(".product-modal__close").click(function () {
            // Remove focus on quickshop modal
            slate.a11y.removeTrapFocus({
                $container: $('#quickshop-modal'),
                namespace: 'quickshop_focus'
            });

            $(".product-modal__container").removeClass("active");
            $(".product-modal__content").empty();
            $("body").css("overflow", "visible")
        })

        // Click anywhere but the modal and trigger close modal
        $(".product-modal__container").click(function () {
            // Remove focus on quickshop modal
            slate.a11y.removeTrapFocus({
                $container: $('#quickshop-modal'),
                namespace: 'quickshop_focus'
            });

            $(this).removeClass("active");
            $(".product-modal__content").empty();
            $("body").css("overflow", "visible")
        });
        $(".product-modal__content").click(function (e) {
            e.stopPropagation();
        });

        // Escape Close Modal
        $(document).on('keyup', function (evt) {
            if (evt.keyCode == 27) {
                // Remove focus on quickshop modal
                slate.a11y.removeTrapFocus({
                    $container: $('#quickshop-modal'),
                    namespace: 'quickshop_focus'
                });

                $(".product-modal__container").removeClass("active");
                $(".product-modal__content").empty();
                $("body").css("overflow", "visible")
            }
        });

        // No modal on mobile
        // enquire.register(theme.config.mediaQueries.smallDown, {
        //     match: function () {
        //         $(".product-modal__close").trigger("click");
        //     },
        //     unmatch: function () {}
        // })
    }
    // Image change for Home Page
    $(".homepage-featured-products__content .color__border, #wrap_slider_spring_2021_page .color__border").click(function () {
        console.log("test");
        var $currentVal = $(this).attr("data-val");
        var $swatch = $(this).closest(".swatch")
        var $link = $swatch.closest(".product-card").find(".product-card__image-container").children(".product-card__link");
        $link.find(".product-card__image.active").removeClass("active");
        $link.children(".product-card__image").each(function () {
            if ($(this).attr("data-title").indexOf($currentVal) > -1) {
                $(this).addClass("active");
                return false
            }
        })
    });
}



function updateColorNamePosition() {
    waitForElm(".product-modal__container__new .product-modal__wrap__row-color-swatchers .product-modal__swatch-container-each--color").then((elm) => {
        console.log("====> ");
        if ($(".product-modal__container.product-modal__container__new").hasClass("active")) {
            var topColorTitle = Math.floor( $('.product-modal__swatch-container-each--color').width() / 41 );
            if (topColorTitle < $(".product-modal__swatch-color-border").length) {
                $(".product-modal__swatch-color-border").each(function(index) {
                    if (topColorTitle > index) {
                        $(this).find('.modal_window-color-label').removeClass('modal_window-color-label__bottom');
                        if(!$('.product-modal__container__new .product-modal__swatch-container').hasClass("pt-3")) {
                            $('.product-modal__container__new .product-modal__swatch-container').addClass("pt-3")
                        }
                    }
                });
            } 
        }
    });
}

function handleQuickshopAddToCartMobile(response, mainElm) {
  if (window.matchMedia('(max-width: 767px)').matches) {
    var nameOfEvent = $(mainElm).hasClass("product-modal__container__new")
      ? "New"
      : "Old";

    DY.API("event", {
      name: `Event - Quickshop Add to Cart (Mobile - ${nameOfEvent})`,
      properties: {
        product_id: response.product_id,
        sku: response.sku,
        quantity: response.quantity,
        price_usd: (response.price / 100).toFixed(2)
      }
    });
  }
}


// Only currently allowing to run on collection / product page
window.addEventListener("load", function () {
    cardModalWindow();
});
